/* german-iodine-messages.js */
/** file contains the german translation for the Iodine-Validation Framework */

const config = {
    after: `[FIELD] muss ein Datum nach dem '[PARAM]' sein.`,
    afterOrEqual: `[FIELD] muss nach: '[PARAM]' liegen oder gleich sein.`,
    array: `[FIELD] muss ein Array sein.`,
    before: `[FIELD] muss vor: '[PARAM]' liegen.`,
    beforeOrEqual: `[FIELD] muss vor: '[PARAM]' liegen order gleich sein.`,
    boolean: `[FIELD] darf nur ja oder nein sein.`,
    date: `[FIELD] muss ein Datum sein.`,
    different: `[FIELD] muss einer anderer sein als '[PARAM]'.`,
    endingWith: `[FIELD] muss mit '[PARAM]' enden.`,
    email: `[FIELD] muss eine valide Emailadresse sein.`,
    falsy: `[FIELD] muss ein "falsy" Wert sein (false, 'false', 0 or '0').`,
    in: `[FIELD] muss eine der folgenden Optionen sein: [PARAM].`,
    integer: `[FIELD] muss eine ganze Zahl sein.`,
    json: `[FIELD] muss ein valides JSON sein.`,
    maximum: `[FIELD] darf nicht größer als '[PARAM]' in Anzahl oder Zeichenlänge sein.`,
    minimum: `[FIELD] darf nicht kleiner als '[PARAM]' in Anzahl oder Zeichenlänge sein.`,
    max: `[FIELD] muss kleiner odere gleich groß sein wie [PARAM].`,
    min: `[FIELD] muss größer odere gleich groß sein wie [PARAM].`,
    maxLength: `[FIELD] darf nicht länger als '[PARAM]' Zeichen sein.`,
    minLength: `[FIELD] darf nicht kürzer als '[PARAM]' Zeichen sein.`,
    notIn: `[FIELD] darf nicht eine der folgenden Optionen sein: [PARAM].`,
    numeric: `[FIELD] muss eine Nummer sein.`,
    optional: `[FIELD] ist optional.`,
    regexMatch: `[FIELD] muss dem regulären Ausdruck entsprechen: [PARAM].`,
    required: `[FIELD] ist verpflichtend.`,
    same: `[FIELD] muss gleich '[PARAM]' sein.`,
    startingWith: `[FIELD] muss mit '[PARAM]' beginnen.`,
    string: `[FIELD] darf nur Buchstaben enthalten.`,
    truthy: `[FIELD] muss ein "truthy" Wert sein (true, 'true', 1 or '1').`,
    url: `[FIELD] muss eine valide URL sein.`,
    uuid: `[FIELD] muss eine valide UUID sein.`,
    name: `[FIELD] enthält ungültige Sonderzeichen.`,
    containsNumber: `[FIELD] muss mindestens eine Zahl enthalten.`,
    street: `[FIELD] enthalten ungültige Zeichen.`,
    postal_code: `[FIELD] muss 4 bzw. 5 Zeichen lang sein.`,
    radio: `[FIELD] muss ausgewählt werden.`,
    checkbox: `[FIELD] muss ausgewählt werden.`,
    select: `[FIELD] muss ausgewählt werden.`,
    iban: `[FIELD] muss ein valider IBAN sein.`,
    bic: `[FIELD] muss ein valide BIC sein.`,
    phone: `[FIELD] muss eine valide Telefonnummer sein.`,
};

export { config };
